import { render, staticRenderFns } from "./IndexSolicitudes.vue?vue&type=template&id=5a17d494"
import script from "./IndexSolicitudes.vue?vue&type=script&lang=js"
export * from "./IndexSolicitudes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports